import '@/scripts/main';
import './theme.scss';
import '../../scripts/snippets/carousel.js';
import '../../scripts/snippets/product-tile.js';
import '../../scripts/snippets/fit-size.js';
import '../../scripts/snippets/custom.js';
import { initMinicart } from '@components/minicart';
import { getCssVariable } from '@general/helpers';
import Headroom from 'headroom.js';

(() => {
  initMinicart();
  // NOTE: Temporary removed wishlist feature
  // initFirstWishlit();

  const announcementBarHeight = parseInt(
    getCssVariable(document.documentElement, '--announcement-bar-height') ??
      '0',
  );
  const headerHeight = parseInt(
    getCssVariable(document.documentElement, '--header-height') ?? '0',
  );

  const headroomEl = document.body;
  const headroom = new Headroom(headroomEl, {
    offset: {
      up: announcementBarHeight,
      down: announcementBarHeight + headerHeight,
    },
    tolerance: 0,
    onUnpin: () => {
      if (headroomEl.classList.contains('keep-focus')) {
        headroomEl.classList.remove('headroom--unpinned');
      } else {
        headroomEl.classList.add('hide-header');
      }
    },
    onPin: () => {
      headroomEl.classList.remove('hide-header');
    },
    onTop: () => {
      if (!headroomEl.classList.contains('keep-focus')) {
        headroomEl.classList.remove('opacize');
      }
      window.requestAnimationFrame(() => {
        headroomEl.classList.remove('animate');
      });
    },
    onNotTop: () => {
      headroomEl.classList.add('opacize');
      window.requestAnimationFrame(() => {
        headroomEl.classList.add('animate');
      });
    },
  });
  headroom.init();
})();
